import { Button, Checkbox, Table, Typography } from 'antd';
import { FC, useEffect, useState } from 'react';
import { putApi } from 'apis';
import { getPermissionObject, permissionObject, toastText } from 'utils/utils';
import styles from './index.module.scss';
import './index.scss';
import { PermissionProps, SideDrawerBodyProps } from './types';

const { Text } = Typography;

const PermissionBody: FC<SideDrawerBodyProps> = (props) => {
	// Inits
	const { Column } = Table;
	const { permissions, closeDrawerByAnimation, selectedRole, isLoading } =
		props;
	const [loading, setLoading] = useState<boolean>(false);

	const [permissionsCopy, setPermissionsCopy] = useState<any>([]);

	useEffect(() => {
		// Create a copy of the permission data for modification
		const formattedPermissionData = getPermissionObject(
			permissionObject,
			permissions
		);
		setPermissionsCopy(formattedPermissionData);
	}, [permissions]);

	// Handle changes in individual permissions
	const PermissionChangeHandler = (
		data: any,
		e: any,
		permissionName: string
	) => {
		const PermissionUpdate = permissionsCopy?.map((item: any) => {
			let duplicateItem = { ...item };

			// --- Handle Daily Attendance special linking ---
			let effectivePermission = permissionName;
			if (item.moduleName === 'Time Logs') {
				console.log('item: ', item);
				if (permissionName === 'add' || permissionName === 'edit') {
					effectivePermission = 'add_edit';
				}
			}

			if (item.id === data.id) {
				if (e.target.checked) {
					if (effectivePermission === 'all') {
						duplicateItem = {
							...duplicateItem,
							all: true,
							view: true,
							edit: true,
							delete: true,
							add: true,
							approval: true,
						};
					} else if (effectivePermission === 'add') {
						duplicateItem = {
							...duplicateItem,
							view: true,
							add: true,
						};
					} else if (effectivePermission === 'edit') {
						duplicateItem = {
							...duplicateItem,
							view: true,
							edit: true,
						};
					} else if (effectivePermission === 'delete') {
						duplicateItem = {
							...duplicateItem,
							view: true,
							delete: true,
						};
					} else if (
						effectivePermission === 'add_edit' &&
						item.moduleName === 'Time Logs'
					) {
						duplicateItem = {
							...duplicateItem,
							view: true,
							add: true,
							edit: true,
						};
					} else {
						duplicateItem = {
							...duplicateItem,
							view: true,
						};
					}

					duplicateItem[permissionName] = true;

					const propertyNames = Object.keys(duplicateItem).filter(
						(key) =>
							key !== 'moduleName' &&
							key !== 'all' &&
							key !== 'isBold'
					);
					const anyFalseValue = propertyNames.some(
						(key) => duplicateItem[key] === false
					);
					duplicateItem.all = !anyFalseValue;
					return duplicateItem;
				} else if (
					effectivePermission === 'all' ||
					effectivePermission === 'view'
				) {
					return {
						...item,
						all: false,
						view: false,
						edit: false,
						delete: false,
						add: false,
					};
				} else if (
					effectivePermission === 'add_edit' &&
					item.moduleName === 'Time Logs'
				) {
					return { ...item, add: false, edit: false, all: false };
				} else {
					return { ...item, [permissionName]: false, all: false };
				}
			}

			return item;
		});

		setPermissionsCopy(PermissionUpdate);
	};

	// Handle saving permissions
	const savePermissionHandler = async () => {
		try {
			setLoading(true);
			// removing the header permission
			const actualPermissions = permissionsCopy.filter(
				(singlePermission: any) => singlePermission.id
			);

			const data = {
				roleId: selectedRole.id,
				permissions: actualPermissions,
			};

			await putApi('/permission', data);

			toastText('Permissions updated successfully', 'success');

			closeDrawerByAnimation();
		} catch (error: any) {
			let message =
				error?.response?.data?.message ||
				`Something went wrong in update permission`;
			toastText(message, 'error');
		} finally {
			setLoading(false);
		}
	};

	// JSX
	return (
		<div className={'permission-details-drawer'}>
			<Table
				// columns={permissionColumn}
				dataSource={permissionsCopy} //permissionsCopy
				pagination={false}
				className={`${styles['dynamic-permission-table']} table-global`}
				rowClassName={(columnData: any) => {
					if (columnData.isBold) {
						return 'table-weight-700';
					} else {
						return '';
					}
				}}
				scroll={{ y: 'calc(100vh - 220px)' }}
				loading={isLoading}
			>
				<Column
					title="Module Name"
					dataIndex="moduleName"
					key="moduleName"
					width={'40%'}
					render={(value: string, rowData: PermissionProps) => {
						const moduleMapping: Record<any, any> = {
							'time logs': 'Daily Attendance',
							'time activities': 'Monthly Summary',
						};
						const displayName =
							moduleMapping[value.toLowerCase()] || value;
						return (
							<Text
								className={
									rowData?.isParentModule === true
										? 'parent-module'
										: 'child-module'
								}
							>
								{displayName}
							</Text>
						);
					}}
				/>
				<Column
					title="All"
					dataIndex="all"
					key="all"
					width={'10%'}
					render={(value: boolean, rowData: PermissionProps) => {
						return (
							<>
								{rowData?.sortId ? (
									<Checkbox
										checked={value}
										defaultChecked={value}
										onChange={(e) =>
											PermissionChangeHandler(
												rowData,
												e,
												'all'
											)
										}
									></Checkbox>
								) : (
									` `
								)}
							</>
						);
					}}
				/>
				<Column
					title="Add"
					dataIndex="add"
					key="add"
					width={'10%'}
					render={(value: boolean, rowData: PermissionProps) => {
						return (
							<>
								{rowData?.sortId ? (
									<Checkbox
										checked={
											rowData.isAddDisabled
												? false
												: value
										}
										defaultChecked={value}
										disabled={rowData.isAddDisabled}
										onChange={(e) =>
											PermissionChangeHandler(
												rowData,
												e,
												'add'
											)
										}
									></Checkbox>
								) : (
									` `
								)}
							</>
						);
					}}
				/>
				<Column
					title="View"
					dataIndex="view"
					key="view"
					width={'10%'}
					render={(value: boolean, rowData: PermissionProps) => (
						<>
							{rowData?.sortId ? (
								<Checkbox
									checked={
										rowData.isViewDisabled ? false : value
									}
									defaultChecked={value}
									disabled={rowData.isViewDisabled}
									onChange={(e) =>
										PermissionChangeHandler(
											rowData,
											e,
											'view'
										)
									}
								></Checkbox>
							) : (
								` `
							)}
						</>
					)}
				/>
				<Column
					title="Edit"
					dataIndex="edit"
					key="edit"
					width={'10%'}
					render={(value: boolean, rowData: PermissionProps) => (
						<>
							{rowData?.sortId ? (
								<Checkbox
									checked={
										rowData.isEditDisabled ? false : value
									}
									defaultChecked={value}
									disabled={rowData.isEditDisabled}
									onChange={(e) =>
										PermissionChangeHandler(
											rowData,
											e,
											'edit'
										)
									}
								></Checkbox>
							) : (
								` `
							)}
						</>
					)}
				/>
				<Column
					title="Delete"
					dataIndex="delete"
					key="delete"
					width={'12%'}
					render={(value: boolean, rowData: PermissionProps) => {
						return (
							<>
								{rowData?.sortId ? (
									<Checkbox
										checked={
											rowData.isDeleteDisabled
												? false
												: value
										}
										defaultChecked={value}
										disabled={rowData.isDeleteDisabled}
										onChange={(e) =>
											PermissionChangeHandler(
												rowData,
												e,
												'delete'
											)
										}
									></Checkbox>
								) : (
									` `
								)}
							</>
						);
					}}
				/>
			</Table>
			<div className={styles['side-drawer-form']}>
				<div className={styles['side-drawer-form__buttons']}>
					<Button
						onClick={savePermissionHandler}
						loading={loading}
						disabled={loading}
						className={`${styles['side-drawer-form__buttons--save']} ${styles['side-drawer-form__buttons--btn']}`}
					>
						Save
					</Button>
					<Button
						className={`${styles['side-drawer-form__buttons--cancel']} ${styles['side-drawer-form__buttons--btn']}`}
						onClick={closeDrawerByAnimation}
						disabled={loading}
					>
						Cancel
					</Button>
				</div>
			</div>
		</div>
	);
};

export default PermissionBody;
